var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 30",
    "aria-label": "Nav Menu"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 29.09h45V25H0v4.09zm0-12.5h45V12.5H0v4.09zM0 0v4.09h45V0H0z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0NSAzMCIgYXJpYS1sYWJlbD0iTmF2IE1lbnUiPgogICAgPHBhdGggZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMCAyOS4wOWg0NVYyNUgwdjQuMDl6bTAtMTIuNWg0NVYxMi41SDB2NC4wOXpNMCAwdjQuMDloNDVWMEgweiIvPgo8L3N2Zz4K";
export { SvgNavMenu as ReactComponent };